export default __webpack_public_path__ + "static/ads-header-98a4621fb9125e01f827396ffa5bea6b.svg";